// DateRangeFilter.js
// import { ORDER_FILTER_KEYS } from '../Filter';
import { Box, useTheme } from '@mui/material';
import { tokens } from '../../../../../theme';
import { invoiceStateMap } from '../../../../../utils/labelColorText';
import { COST_FILTER_KEYS } from '../../Filter';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import cx from 'classnames'; // Importing cx from classnames
import { useDispatch, useSelector } from 'react-redux';
import { useGridFilter } from '../../../../../contexts/GridFilterContext';
import { updateFilter } from '../../../../../newapi/global/filter/gridFilterSlice';

const CostTypeFilter = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();
    const filterKey = COST_FILTER_KEYS.TYPE.backend_key;
    const dispatch = useDispatch();

    const { index,id } = useGridFilter();
    const filterObject = useSelector((state) => {
        const instance = state.gridFilter.viewInstances[index];
        return instance ? instance[id] : undefined;
    });

    const productTypes = [
        {label: "shipment", color: "blue"},
        {label: "barcode", color: "grey"},
        {label: "inbound_manual", color: "purple"},
        {label: "inbound_processing", color: "purple"},
        {label: "return", color: "lightblue"},
        {label: "return_manual", color: "lightblue"},
        {label: "return_shipment", color: "lightblue"},
        {label: "pickandpack", color: "orange"},
        {label: "addonpickandpack", color: "orange"},
        {label: "storage_pallet", color: "pink"},
        {label: "storage_product", color: "pink"},
        {label: "surcharges", color: "grey"},
        {label: "adjustment_charges", color: "grey"},
        {label: "finalize_invoice", color: "green"}
    ];

    const handleStateToggle = (itemState) => {
        if (filterObject && filterObject.filter) {
            const currentStates = filterObject.filter[filterKey] || [];

            // Check if the clicked labeltext is already in the backendKey (active states)
            const updatedStates = currentStates.includes(itemState)
                ? currentStates.filter(state => state !== itemState) // Remove if already active
                : [...currentStates, itemState]; // Add if not active

            // Dispatch the action to update the filter with the new active states
            dispatch(updateFilter({ index, id, filterKey, value: updatedStates }));
        }
    };

  
    return (
        <Box
            sx={{
                display:"flex",
                flexDirection:"column",
                gap:1.5,
            }}
        >
            {productTypes.map((productType,index) => {
                return (
                    <Box
                        className={cx({
                            active: filterObject && filterObject.filter?.[filterKey]?.includes(productType.label), // Add the 'active' class if state is active
                        })}
                        onClick={() => handleStateToggle(productType.label)}
                        key={index + productType.label}
                        sx={{
                            height:40,
                            border: `1px solid ${theme.palette.mode === "dark" ? colors.grey[400] :colors.grey[100]}`,
                            p:0.5,
                            borderRadius:5,
                            display:"flex",
                            alignItems:'center',
                            "&.active " : {
                                background: colors.pastel.light[productType.color][100],
                                border: `1px solid ${colors.pastel.light[productType.color][200]}`,
                            }
                        }}
                    >
                        <Box
                            sx={{
                                height:32,
                                lineHeight:"32px",
                                background: colors.pastel.light[productType.color][100],
                                color: colors.pastel.light[productType.color][600],
                                border: `1px solid ${colors.pastel.light[productType.color][600]}`,
                                fontFamily:"Roboto, sans-serif",
                                fontSize:14,
                                // fontWeight:500,
                                display:"inline-flex",
                                minWidth:120,
                                px:2,
                                alignItems:"center",
                                justifyContent:"center",
                                borderRadius:4,
                            }}
                        >
                            {t(productType.label)}
                        </Box>

                    </Box>
                );
            })}
            
        </Box>
    );
};

export default CostTypeFilter;